<script setup lang="ts">
/**
 * Gradient "AI" ring that wraps the AI search field on the dashboard and the
 * results page, so both render the same treatment.
 */
</script>

<template>
  <div class="ai-search-ring rounded-full p-0.5">
    <slot />
  </div>
</template>

<style scoped>
.ai-search-ring {
  background: linear-gradient(
    90deg,
    #f6b22b 0%,
    rgb(102 91 250 / 40%) 79.33%,
    #427dff 100%
  );
}

.ai-search-ring :deep(input),
.ai-search-ring :deep(.input-wrapper) {
  border-color: transparent;
}
</style>
